var conference = window.conference || {};

conference.front = {
	minDate: function () {
		$('#startDate').bind('change', function () {
			var $start = $('#startDate');
			var $finish = $('#endDate');
			var startArr = $start.val().split('.');
			var start = startArr[2] + startArr[1] + startArr[0];
			var finishArr = $finish.val().split('.');
			var finish = finishArr[2] + finishArr[1] + finishArr[0];

			if ($finish.val() === '' || finish < start) {
				$finish.val($start.val());
			}
			$finish.datepicker('option', 'minDate', new Date(startArr[2], startArr[1] - 1, startArr[0]));
		});
	},

	carousel: function () {
		site.owl.init('.hotel__images.owl', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			animateOut: 'fadeOut',
			loop: true,
			lazyLoad: true,
		});
	},
};
